import { PropsWithChildren, ReactElement } from 'react';

function AlertDanger(
  props: PropsWithChildren<any>
): ReactElement<HTMLParagraphElement> {
  return (
    <p className="mb-5 px-5 py-2 bg-red-100 text-sm text-primary font-body">
      {props.children}
    </p>
  );
}

export default AlertDanger;
